export default __webpack_public_path__ + "98eea23aed7e7e4eb6c6a0f3cf0715fc.svg";